import { Component, OnInit } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LookupItem } from '../../../../viewmodels/static-lookups/lookup-item';
import { DashboardService } from '../../dashboard.service';
import { WidgetDataType } from '../widget-data-type';

@Component({
  selector: 'hb-add-widget-dialog',
  templateUrl: './add-widget-dialog.component.html',
})
export class AddWidgetDialogComponent implements OnInit {
  public selectedWidgetDataType = null;

  widgetDataTypes: LookupItem[] = [
    new LookupItem(WidgetDataType.HighRiskItems, this.i18NextPipe.transform('Widgets.HighRiskItems')),
    new LookupItem(WidgetDataType.RiskDistribution, this.i18NextPipe.transform('Widgets.RiskDistribution')),
    new LookupItem(WidgetDataType.OverdueMitigations, this.i18NextPipe.transform('Widgets.OverdueMitigations')),
    new LookupItem(WidgetDataType.MitigationsDue, this.i18NextPipe.transform('Widgets.MitigationsDue')),
    new LookupItem(WidgetDataType.MitigationsDueByMonth, this.i18NextPipe.transform('Widgets.MitigationsDueByMonth')),
    new LookupItem(WidgetDataType.CompletedReports, this.i18NextPipe.transform('Widgets.CompletedReports')),
    new LookupItem(WidgetDataType.AssetCount, this.i18NextPipe.transform('Widgets.AssetCount')),
    new LookupItem(WidgetDataType.PlannedMaintenanceImprovements, this.i18NextPipe.transform('Widgets.MaintenanceOptimization')),
    new LookupItem(WidgetDataType.PlannedMaintenanceDistribution, this.i18NextPipe.transform('Widgets.PlannedMaintenanceDistribution')),
  ]
    .filter(e => this.dashboardService.checkUserHasPermissionsForWidget(e.key))
    .sort((a, b) => a.value.localeCompare(b.value));

  constructor(public bsModalRef: BsModalRef, public dashboardService: DashboardService, private i18NextPipe: I18NextPipe) { }

  ngOnInit() { }

  addEnabled(): boolean {
    return this.selectedWidgetDataType ? true : false;
  }

  apply() {
    this.dashboardService.createDashbaordWidget(this.selectedWidgetDataType);
    this.bsModalRef.hide();
  }
}
